import React from 'react';
import styled from 'styled-components';
import {device} from '../../assets/device'

import {parseDatetimeString} from '../../services/dates';

export const EventDateInfoStyles = {
	DateInfo: styled.div`
      margin-bottom: 0.75em;
      background-color: #f7f7f7;
      display: flex;
      height: 100%;
      word-break: keep-all;
      //noinspection ALL
      @media ${device.tablet} {
        flex-wrap: wrap;
        padding: .5rem 0 0;
      }

      .date-info__date {
        color: #b2aeae;
        font-size: 4.5em;
        line-height: .9em;
        font-weight: 700;
        flex: 1;
        letter-spacing: -3px;
        text-align: right;
        width: 20%;
        display: flex;
        justify-content: flex-end;
        //noinspection ALL
        @media ${device.tablet} {
          padding: 0 0 1rem .4rem;
          width: 50%;
          font-size: 5em;
        }
      }
      .date-info__month-weekday {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        width: 33%;
        padding: 0 .5rem .5rem .7rem;
        //noinspection ALL
        @media ${device.tablet} {
          width: 50%;
          padding: 0 .5rem 0 .7rem;
        }
        div {
          width: 100%;
          overflow: hidden;
          &.date-info__month {
            font-weight: 600;
            font-size: 1.6em;
          }
          &.date-info__weekday {
            font-size: .9em;
            text-overflow: ellipsis;
          }
        }
      }
      .date-info__date-time {
        width: 47%;
        height: 100%;
        background-color: #484646;
        align-self: flex-end;
        color: #fff;
        padding: .5rem 1rem;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: .9em;
        //noinspection ALL
        @media ${device.tablet} {
          width: 100%;
          height: 40%;
        }
        div {
          width: 100%;
          line-height: 1em;
          font-weight: 300;

          &:first-child {
            font-weight: 600;
          }
        }

        .date-time__label {
          width: 45%;
        }

        .date-time__value {
          float: right;
        }

      }
	`,
};

const S = EventDateInfoStyles;

const EventDateInfo = ({event}) => {
	const beginDate = parseDatetimeString(event.begin).format('DD');
	const beginWeekday = parseDatetimeString(event.begin).format('dddd');
	const beginMonth = parseDatetimeString(event.begin).format('MMM');
	const beginTimeStr = parseDatetimeString(event.begin).format('HH:mm');
	const entryTime = event.doorsOpenOffset ? parseDatetimeString(event.begin).subtract(event.doorsOpenOffset, 'm').format('HH:mm') : null;

	return (
		<S.DateInfo>
			<div className="date-info__date">
				{beginDate}
			</div>
			<div className="date-info__month-weekday">
				<div className="date-info__month">{beginMonth}</div>
				<div className="date-info__weekday">{beginWeekday}</div>
			</div>
			<div className="date-info__date-time">
				<div><span className="date-time__label">Start:</span><span
					className="date-time__value">{beginTimeStr} Uhr</span></div>
				{entryTime && <div><span className="date-time__label">Einlass:</span><span
					className="date-time__value">{entryTime} Uhr</span></div>}
			</div>
		</S.DateInfo>
	);
};

export default EventDateInfo;
